import {
  Component,
  computed,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { AuthenticationService } from '../../authentication/authentication.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProfileDataService } from '../../services/data/profile-data.service';
import {
  EmployeeMessageType,
  EmployeeMessagingService,
} from '../../services/signaling/messaging/employee-messaging.service';
import { Employee } from '../../model/employee/employee';

@Component({
  selector: 'app-menu-bar-employee-info',
  imports: [
    MatDivider,
    MatIcon,
    MatMenu,
    MatMenuItem,
    RouterLink,
    MatMenuTrigger,
  ],
  templateUrl: './menu-bar-employee-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './menu-bar-employee-info.component.scss',
})
export class MenuBarEmployeeInfoComponent {
  private static DEFAULT_AVATAR_PATH = 'assets/images/default_profile_icon.svg';
  protected employee$ = signal<Employee | null>(null);
  protected employeeDisplayName$ = computed(() => {
    const employee = this.employee$();
    if (employee) {
      if (employee.firstName && employee.lastName) {
        return `${employee.firstName} ${employee.lastName}`;
      } else if (employee.firstName) {
        return employee.firstName;
      } else if (employee.lastName) {
        return employee.lastName;
      } else if (employee.email) {
        return employee.email;
      }
    }

    return `User`;
  });
  protected employeeAvatarPath$ = computed(() => {
    const employee = this.employee$();
    return (
      employee?.avatarPath ?? MenuBarEmployeeInfoComponent.DEFAULT_AVATAR_PATH
    );
  });

  constructor(
    protected readonly profileDataService: ProfileDataService,
    private readonly authService: AuthenticationService,
    private readonly employeeSignalingService: EmployeeMessagingService,
    private readonly snackBar: MatSnackBar,
  ) {
    this.employeeSignalingService
      .onMessage(EmployeeMessageType.employeeChanged)
      .subscribe((employee: Employee) => {
        this.profileDataService.updateEmployeeInformation(employee);
      });

    this.profileDataService.loadProfileData().subscribe();

    this.profileDataService.employeeInformation$.subscribe((employee) =>
      this.employee$.set(employee),
    );
  }

  onLogout() {
    this.authService.logout().then(() => {
      this.snackBar.open($localize`Benutzer wurde abgemeldet.`);
    });
  }
}
